export default "__VITE_ASSET__BjBYc0eO__"